// unit px
const ITEM_WIDTH = 189;
const ITEM_WIDTH_SP = 100;
const MINIMUM_DISPLAY_SIZE = 320;

const displayWidth = window.innerWidth;

// numerical adjustment for SP
const realityItemWidth = ITEM_WIDTH_SP * (displayWidth / MINIMUM_DISPLAY_SIZE);

/**
 * 左向の矢印をクリックした際に、左端まで移動する
 */
export function autoScrollLeft() {
  const buttons = document.querySelectorAll('.js-left');
  const button = Array.prototype.slice.call(buttons, 0);

  button.forEach((e) => {
    e.addEventListener('click', () => {
      const lists = document.querySelectorAll('.xp_thumbnails');
      const list = Array.prototype.slice.call(lists, 0);

      list.forEach((l) => {
        if (e.dataset.key == l.id) {
          l.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
          });
        }
      });
    });
  });
}

/**
 * 右向の矢印をクリックした際に、右端まで移動する
 */
export function autoScrollRight() {
  const buttons = document.querySelectorAll('.js-right');
  const button = Array.prototype.slice.call(buttons, 0);

  let scrollValue = ITEM_WIDTH;

  // SP幅
  if (window.matchMedia('(max-width: 767px)').matches) {
    scrollValue = realityItemWidth;
  }

  button.forEach((e) => {
    e.addEventListener('click', () => {
      const lists = document.querySelectorAll('.xp_thumbnails');
      const list = Array.prototype.slice.call(lists, 0);

      list.forEach((l) => {
        if (e.dataset.key == l.id) {
          const number = l.childElementCount;
          l.scrollTo({
            top: 0,
            left: scrollValue * number,
            behavior: 'smooth',
          });
        }
      });
    });
  });
}